module.exports = new __parcel__URL__("MondaySelectBoardIllustrationStandard.26885b16.svg").toString();